import React from "react";
import { useHistory } from "react-router-dom";
import { Aside, EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { AssetCreationWarning } from "../../../../common/components/AssetCreationWarning";
import { useOnPremAssetDetails } from "../../../common/hooks/useOnPremAssetDetails";
import { resolveOnPremAssetHref } from "../../../common/resolveOnPremAssetHref";
import { isOnPremAssetDeprecated } from "../../../OnPremAssetDetails";
import { OnPremVideoAssetTechnicalForm } from "./OnPremVideoAssetTechnicalForm";

export interface EditOnPremVideoAssetTechnicalAsideProps {
    isLabeled?: boolean;
}

export const EditOnPremVideoAssetTechnicalAside = (props: EditOnPremVideoAssetTechnicalAsideProps): JSX.Element => {
    const { isLabeled } = props;

    const { data: assetDetails, isLoading } = useOnPremAssetDetails();

    const areActionsDisabled = assetDetails && (isOnPremAssetDeprecated(assetDetails) || isLoading);

    const { isOpen, onOpen, onClose } = useDisclosure();

    const history = useHistory();

    const onSubmit = (newAssetId: string) => {
        if (!assetDetails) {
            return;
        }

        const newHref = resolveOnPremAssetHref(assetDetails.content.subtype, newAssetId);
        history.push(newHref);
        onClose();
    };

    if (!assetDetails) {
        return <></>;
    }

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                disabled={areActionsDisabled}
                testId="edit-video-technical"
            />
            <Aside type="form" headerText="Edit technical" isOpen={isOpen} onDismiss={onClose} isLightDismiss={true}>
                <AssetCreationWarning />
                <OnPremVideoAssetTechnicalForm onDismiss={onClose} onSubmit={onSubmit} assetId={assetDetails.assetId} />
            </Aside>
        </AuthorizationWrapper>
    );
};
